import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';

Component('tr-kanban-todolists-header', {
  mixins: [eventListenerMixin],

  properties: {
    sticky: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.container = closest(this, '.todolists');
    this.listenTo(this.container, 'scroll', () => {
      this.sticky = this.container.scrollTop > 0;
    });
  },

  ready() {
    this.initSortTodolist();
  },

  initSortTodolist() {
    const kanban = closest(this, 'tr-project-kanban');

    $(this).sortable({
      axis: 'x',
      distance: 5,
      items: 'tr-kanban-todolist-title',
      placeholder: 'todolist-placeholder',
      start(e, ui) {
        ui.placeholder.css({ height: '100vh' });
        ui.item.css({ height: '100vh' });
      },
      update(e, ui) {
        const guids = Array.prototype.map.call(
          e.target.querySelectorAll('tr-kanban-todolist-title'),
          todolist => todolist.guid,
        );
        $.ajax({
          url: ui.item.data('sort-url'),
          type: 'post',
          dataType: 'json',
          data: {
            guids: guids.join(','),
          },
          success(result) {
            if (result.success) kanban.reload();
          },
        });
      },
    });
  },

  disconnected() {
    this.stopListening();
  },
});
